import React from 'react';

import { useIntl } from 'react-intl';

import { useCreatePayStation } from 'src/features/payment/api/useCreatePayStation';
import { LIST_PAY_STATIONS_RESOURCE } from 'src/features/payment/api/useListPayStations';
import PayStationFormModal from 'src/features/payment/components/forms/PayStationFormModal';
import { paymentsMessages } from 'src/features/payment/utils/messages';
import { PayStation } from 'src/features/payment/utils/types';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';

interface PayStationFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedPayStation?: PayStation;
    children?: React.ReactNode;
}

function CreatePayStationFormModal<TData>({ className, semantics }: PayStationFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { parkingId } = useParking();
    const { mutate, isPending } = useCreatePayStation({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_PAY_STATIONS_RESOURCE] });
            toast({
                title: formatMessage(paymentsMessages.createPayStationSuccess),
                description: formatMessage(paymentsMessages.createPayStationSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <PayStationFormModal
            className={className}
            mutate={(data, onSuccess, onError) =>
                mutate({ parkingId, data }, { onSuccess, onError })
            }
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(paymentsMessages.addPayStationSubtitle)}
        />
    );
}

export default CreatePayStationFormModal;
